export const paths = {
  root: '/',
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  onboarding: '/onboarding',
  scheduler: '/scheduler',
  conflicts: '/conflicts',
  singleProject: '/project/:id',
  manager: '/manager',
  projectInvitationAcceptance: '/project-invitation',
} as const;
